// extracted by mini-css-extract-plugin
export var defaultWrapper = "_l1-3";
export var downloadButton = "_l1-4";
export var fileContainer = "_l1-9 _l1-7";
export var fileContainerBase = "_l1-7";
export var fileContainerFixedHeight = "_l1-8 _l1-7";
export var fileInfo = "_l1-5";
export var fileInfoWidthRestricted = "_l1-6";
export var fileType = "_l1-1";
export var fileTypeName = "_l1-2";
export var image = "_l1-0";
export var link = "_l1-b";
export var overflowEllipsis = "_l1-a";